<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid, reset, errors}" ref="observer">
    <artisio-modal size="lg" :visible="modal.show" :data="model" scrollable
                   :title="computedTitle" @show="onShow" :modal-loading="loading"
                   @hidden="onHidden" @ok.prevent="onSubmit" :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')" :is-loading="loading" modal-class="mobile-full-screen">

      <div class="row" v-if="customerUuid">
        <div class="col-md-6">
          <input-widget :model="model" attribute="copy_from_uuid" value-field="uuid" @select2Select="onCopySelect"
                        :display-field="addressDisplayField" type="select2" :items="allAddresses"
                        :options="select2Options"/>
        </div>
        <!--        <div class="col-md-6 text-right">-->
        <!--          <b-button variant="primary" @click="onCopyAddressClick" :disabled="loading">-->
        <!--            <span v-if="loading"-->
        <!--                  class="spinner-border spinner-border-sm"-->
        <!--                  role="status"-->
        <!--                  style="width: 1.3em;height: 1.3em;margin-right: 1em"-->
        <!--                  aria-hidden="true"></span>-->
        <!--            {{ btnTitle }}-->
        <!--          </b-button>-->
        <!--        </div>-->
      </div>

      <div class="row">
        <div class="col-md-12">
          <hr class="mt-0"/>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <country-select-input-widget attribute="country_code" :model="model" @select="onCountrySelect"/>
        </div>
        <div class="col-md-6">
          <input-widget :model="model" attribute="address_1"/>
        </div>
        <div class="col-md-6">
          <input-widget :model="model" attribute="address_2"/>
        </div>
        <div class="col-md-6">
          <state-input-widget v-if="isAvalaraEnabled && model.country_code === 'US'" :model="model" attribute="state"/>
          <input-widget :model="model" attribute="state" v-else/>
        </div>
        <div class="col-md-6">
          <input-widget :model="model" attribute="county"/>
        </div>
        <div class="col-md-6">
          <input-widget :model="model" attribute="city"/>
        </div>
        <div class="col-md-6">
          <post-code-input-widget :model="model" attribute="zip_code"/>
        </div>
        <div class="col-md-6">
          <input-widget :model="model" attribute="email"/>
        </div>
        <div class="col-md-6">
          <input-widget :model="model" attribute="phone"/>
        </div>
        <div class="col-md-6">
          <input-widget :model="model" attribute="first_name"/>
        </div>
        <div class="col-md-6">
          <input-widget :model="model" attribute="last_name"/>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import ArtisioModal from "./../artisio-modal/ArtisioModal";
  import InputWidget from "@/core/components/input-widget/InputWidget";
  import CountrySelectInputWidget from "@/core/widgets/CountrySelectInputWidget";
  import PostCodeInputWidget from "@/core/widgets/PostCodeInputWidget";
  import AddressModel from "@/core/components/address-modal/AddressModel.model";
  import CustomerService from "@/modules/customer/CustomerService";
  import StateInputWidget from "@/core/widgets/StateInputWidget.vue";

  const {mapState, mapActions, mapGetters: globalMapGetters} = createNamespacedHelpers('global');

  export default {
    name: "AddressModal",
    components: {
      StateInputWidget,
      PostCodeInputWidget,
      CountrySelectInputWidget,
      InputWidget,
      ArtisioModal
    },
    data() {
      return {
        loading: false,
        showConfirmation: true,
        model: new AddressModel(),
        allAddresses: [],
        select2Options: {
          escapeMarkup: function (markup) {
            return markup; // Do not escape HTML
          },
        },
        starSvg: `<svg  data-v-9440dfd4="" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="star" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="svg-inline--fa fa-star fa-w-18 text-primary"><path data-v-9440dfd4="" fill="currentColor" d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z" class=""></path></svg>`
      }
    },
    computed: {
      ...mapState({
        modal: state => state.addressModal,
        customerUuid: state => state.addressModal.customerUuid,
        editObject: state => state.addressModal.object,
      }),
      ...globalMapGetters(['isAvalaraEnabled']),
      computedTitle() {
        return this.model.type === 'billing' ? this.$i18n.t(`Update Billing Address`) : this.$i18n.t('Update Shipping Address')
      },
      btnTitle() {
        return this.$i18n.t("Same as Current {} Address", {type: this.model.type})
      }
    },
    watch: {
      editObject() {
        if (this.editObject) {
          this.model = new AddressModel(this.editObject)
        }
      }
    },
    methods: {
      ...mapActions(['hideAddressModal']),
      addressDisplayField(item) {
        let type = item.type === 'billing' ? this.$i18n.t('Billing') : this.$i18n.t('Shipping')
        let items = [
          item.address_1,
          item.city,
          item.country ? item.country.name : null,
          item.zip_code
        ]
        return `${item.is_primary ? this.starSvg : ''} ${type} - ${items.filter(v => v && v.trim() !== '').join(', ')}`
      },
      async onShow() {
        this.showConfirmation = true

        this.loading = true
        let response = await CustomerService.getCustomerAddresses(this.customerUuid, {
          expand: 'country',
          type: this.model.type
        })
        if (response.success) {
          this.allAddresses = response.body
        }
        this.loading = false
      },
      onHidden() {
        this.allAddresses = []
        this.showConfirmation = true
        this.model = new AddressModel();
        this.hideAddressModal();
      },
      async onSubmit() {
        await this.$refs.observer.reset();
        let validateSuccess = await this.$refs.observer.validate();
        if (!validateSuccess) {
          return false;
        }

        this.showConfirmation = false;

        this.$evBus.$emit(`onAddressUpdate-${this.modal.modalReference}`, {
          object: this.model.toJSON(),
        })

        this.hideAddressModal()
      },
      onCountrySelect(country) {
        this.model.country = country
      },
      async onCopyAddressClick() {
        this.loading = true
        if (this.allAddresses.length > 0 && this.model.type) {
          let tmpAddr = this.allAddresses.find(a => a.is_primary && a.type === this.model.type)
          if (tmpAddr) {
            this.setAddress(tmpAddr)
          }
        }
        this.loading = false
      },
      setAddress(tmpAddr) {
        this.model = new AddressModel({
          address_1: tmpAddr.address_1,
          address_2: tmpAddr.address_2,
          city: tmpAddr.city,
          county: tmpAddr.county,
          state: tmpAddr.state,
          zip_code: tmpAddr.zip_code,
          email: tmpAddr.email,
          phone: tmpAddr.phone,
          first_name: tmpAddr.first_name,
          last_name: tmpAddr.last_name,
          type: tmpAddr.type,
          country_code: tmpAddr.country ? tmpAddr.country.country_code : null,
          country: tmpAddr.country,
        })
      },
      onCopySelect(val) {
        this.setAddress({
          ...val,
          type: this.model.type
        })
      }
    }
  }
</script>

<style scoped>

</style>
